import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { colors } from "../../Assets/styles/colors";
import { useTranslate } from '@tolgee/react';
import { ReactComponent as PlusIcon } from "../../Assets/icons/PlusIcon.svg";
import { ReactComponent as GenericAvatar } from "../../Assets/iconsv2/generic/GenericAvatar.svg"
import { ReactComponent as AvatarPencil } from "../../Assets/icons/avatarPencil.svg";
import { ReactComponent as LeaveGroupIcon } from "../../Assets/icons/logoutIcon.svg";

import { useAuthService } from "../../Context/AuthContext";
import ContactElementChatDetails from "../Chat/ChatDetailsContactElement";
import { Item, Menu, Submenu, useContextMenu } from "react-contexify";
import DeleteConfirmationChild from "../GenericComponents/DeleteConfirmationChild";
import PrimaryButton from "../GenericComponents/PrimaryButton";
import PrimaryButtonRemove from "../GenericComponents/PrimaryButtonRemove";
import { ADD_MEMBERS } from "../../Constants/constantValues";
import { displayAvatar, displayUserAvatar } from "../../Helpers/chatHelper/AvatarHelper";

const CustomItem = ({ text, icon, redButton }) => {
  return (
    <CustomItemContainer redButton={redButton}>
      <p>{text}</p>
      {icon}
    </CustomItemContainer>
  );
};

const GroupSelectedMembers = ({
  inputValues,
  setOption,
  previewAvatar,
  handleInputChange,
  handleOpenAvatar,
  handleAvatarChange,
  profileAvatarRef,
  selectedContacts,
  groupData,
  handleRemoveMember,
  initialContacts,
  handleMakeAdmin,
  handleRevokeAdmin
}) => {
  const { t } = useTranslate();
  const buttonList = [
    {
      id: "make_admin",
      text: t('chat_details.make_admin'),

    },
    {
      id: "revoke_admin",
      text: t('chat_details.revoke_admin'),
      redButton: true,
      withConfirmation: true
    },

    {
      id: "remove_user",
      text: t('chat_details.remove_user'),
      redButton: true,
      withConfirmation: true

    },
  ]
  const { user } = useAuthService();
  const [croupMembersNumber, setGroupMembersNumber] = useState(0);
  const [removeUserConfirmation, setRemoveUserConfirmation] = useState(false);
  const [revokeAdminConfirmation, setRevokeAdminConfirmation] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [isCurrentUserAdmin, setIsCurrentUserAdmin] = useState(false)

  const calculateGroupMembers = () => {
    let found = groupData.other_participants.find(
      (item) => item.id === user.id
    );
    var number = 0;
    if (!found) {
      number = groupData.other_participants.length + 1;
    } else {
      number = groupData.other_participants.length;
    }
    setGroupMembersNumber(number);
  };

  const MENU_ID = "groupDetailsMenu-id";

  const { show } = useContextMenu({
    id: MENU_ID,
  });

  function displayMenu(e, user) {
    // put whatever custom logic you need
    // you can even decide to not display the Menu
    setSelectedMember(user);
    show({
      event: e,
    });
  }

  function handleItemClick({ id }) {
    switch (id) {
      case "make_admin":
        handleMakeAdmin(selectedMember)
        break;
      case "revoke_admin":
        setRevokeAdminConfirmation(true)
        break;
      case "remove_user":
        setRemoveUserConfirmation(true)
        break;
      default:
        break;
    }
  }

  const checkIfUserIsAdmin = (contact) => {
    if (!contact) {
      return
    }

    let isAdmin = groupData?.admin_ids?.find((item) => item === contact.id)

    return isAdmin
  }

  const filterButtons = (buttons) => {
    let availableOptions = buttons;
    if (!user || !selectedMember) {
      return availableOptions
    }

    const userIsAdmin = checkIfUserIsAdmin(selectedMember);

    if (selectedMember.id === user.id) {
      availableOptions = availableOptions.filter((item) => item.id !== "remove_user")
    }
    if (!userIsAdmin) {
      availableOptions = availableOptions.filter((item) => item.id !== "revoke_admin")
    }
    if (userIsAdmin) {
      availableOptions = availableOptions.filter((item) => item.id !== "make_admin")
    }

    return availableOptions
  }

  const handleLeaveGroup = (user) => {

    setSelectedMember(user);
    setRemoveUserConfirmation(true)
  }

  useEffect(() => {
    if (checkIfUserIsAdmin(user)) {
      setIsCurrentUserAdmin(true)
    } else {
      setIsCurrentUserAdmin(false)
    }
  }, [groupData])

  useEffect(() => {
    calculateGroupMembers();
  }, [groupData.other_participants]);


  return (
    <>
      <Group>
        <TitleWrapper>
          <h1>{t('chat_details.group_details')}</h1>
        </TitleWrapper>
        <OptionWrapper>
          <ProfileDetails>
            <UserWrapper>

              <input
                type="file"
                hidden
                accept=".png, .jpg, .jpeg "
                ref={profileAvatarRef}
                onChange={(e) => {
                  handleAvatarChange(e)
                }}
              />
              <UserAvatarWrapper>

                <UserAvatar onClick={() => {
                  handleOpenAvatar()
                }}>
                  {previewAvatar ? (
                    <PreviewAvatar>
                      <img src={previewAvatar} alt="avatar" />
                    </PreviewAvatar>
                  ) : (
                    displayAvatar(groupData)
                  )}
                </UserAvatar>
                <EditButton onClick={() => handleOpenAvatar()}>
                  {t('general.edit').toUpperCase()}
                </EditButton>
              </UserAvatarWrapper>

              <CustomNameInput
                value={inputValues.groupName}
                onChange={(e) => handleInputChange(e)}
                placeholder={t('new_chat.enter_group_name')}
                name="groupName"
                maxLength={100}
              >

              </CustomNameInput>
            </UserWrapper>
          </ProfileDetails>
        </OptionWrapper>
      </Group>
      <Separator />
      {checkIfUserIsAdmin(user) &&
        <Group>
          <TitleWrapper>
            <h1>{t('new_chat.add_members')}</h1>
          </TitleWrapper>
          <ChatOption style={{ flexDirection: "column" }}>
            <PrimaryButton
              style={{ padding: "16px" }}
              onClick={() => setOption(ADD_MEMBERS)}
              iconLeft={<PlusIcon />}
              text={t('new_chat.add_members')}
            />

          </ChatOption>
        </Group>

      }
      <Group>
        <ChatOption style={{ flexDirection: "column" }}>
          <DeleteConfirmationChild>
            <PrimaryButtonRemove
              style={{ padding: "16px" }}
              onClick={(e) => handleLeaveGroup(user)}
              iconLeft={<LeaveGroupIcon />}
              text={t('chat_details.leave_group')}
            />
          </DeleteConfirmationChild>
        </ChatOption>
      </Group>
      {initialContacts?.length > 0 && (
        <Group>
          <TitleWrapper>
            <h1>
              {croupMembersNumber} {t('new_chat.members')}
            </h1>
          </TitleWrapper>
          <MebersList>
            <ContactElementChatDetails
              item={user}
              variant={user.id === user.id ? "me" : ""}
              displayMenu={displayMenu}
              isCurrentUserAdmin={isCurrentUserAdmin}
              isUserAdmin={checkIfUserIsAdmin(user)}
            />
            {initialContacts?.map((contact, index) => (
              <ContactElementChatDetails
                key={index}
                item={contact}
                variant={contact.id === user.id ? "me" : ""}
                displayMenu={displayMenu}
                isCurrentUserAdmin={isCurrentUserAdmin}
                isUserAdmin={checkIfUserIsAdmin(contact)}
              />
            ))}
          </MebersList>

          <StyledMenu id={MENU_ID}>
            {filterButtons(buttonList).map((item, index) => {
              if (item.withConfirmation) {
                return (
                  <Item onClick={handleItemClick} id={item.id} key={index}>
                    <CustomItem onClick={handleItemClick} text={item.text} redButton={item.redButton} />
                  </Item>
                )
              } else {
                return (
                  <Item onClick={handleItemClick} id={item.id} key={index}>
                    <CustomItem onClick={handleItemClick} text={item.text} redButton={item.redButton} />
                  </Item>
                )
              }
            }
            )}
          </StyledMenu>


        </Group>
      )}

      <DeleteConfirmationChild
        setOpen={setRemoveUserConfirmation}
        open={removeUserConfirmation}
        action={handleRemoveMember}
        item={selectedMember}
        variant={selectedMember?.id === user.id ? "me" : ""}
      />

      <DeleteConfirmationChild
        setOpen={setRevokeAdminConfirmation}
        open={revokeAdminConfirmation}
        action={handleRevokeAdmin}
        item={selectedMember}
        variant={"revoke_admin"}
      />

    </>
  );
};

export default GroupSelectedMembers;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  h1 {
     color:${({ theme }) => theme.menu.infoText};
  font-size: 14px;
    font-weight: 500;
    line-height: 16px;
  text-transform:uppercase;
  }
`;
const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding:10px 16px;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  border-radius: 4px;
`;

const ProfileDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const UserAvatar = styled.div`
  display: flex;
  align-items: center;
  border-radius: 100px;
  cursor: pointer;
  max-height: 42px;
  max-width: 42px;
  min-width: 42px;
  min-height: 42px;

`;


const UserWrapper = styled.div`
  display: flex;
  gap: 10px;


  h1 {
    font-size: 20px;
    font-weight: 500;
    line-height: 22px;
    color: ${({ theme }) => theme.menu.primaryTextColor};
  }
`;

const CustomInput = styled.input`
margin-top:10px;
height:24px;
  background: none;
  border: none;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.40799999237060547px;
  &:focus-visible {
    outline: none;
  }
`;

const ChatOption = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  border-bottom: 1px solid #363e5180;
  &:last-child {
    border: none;
  }
  h1 {
    min-width: 75px;
    color: #ffffff99;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.40799999237060547px;
  }
  h2 {
    text-transform: capitalize;
    color: ${({ theme }) => theme.menu.primaryTextColor};
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.40799999237060547px;
  }
`;

const CustomNameInput = styled(CustomInput)`
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  width:100%;
  text-overflow:ellipsis;
`;

const Separator = styled.div`
  background: ${({ theme }) => theme.sidebar.borderColor};
  height: 1px;
  width: 100%;
`;


const UserAvatarWrapper = styled.div`
  position: relative;
  gap:3px;
  display:flex;
  flex-direction:column;
`;



const MebersList = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  border-radius: 4px;
  padding: 10px 16px;
  gap: 8px;
`;

const CustomItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: ${({ redButton, theme }) => (redButton ? colors.errorColor : theme.menu.primaryTextColor)};
  svg {
    height: 20px;
    width: 20px;
  }
`;

const StyledMenu = styled(Menu).attrs({
  // custom props
})`
  background: ${({ theme }) => theme.menu.background};
  color: white;
  padding: 0;
  border-radius: 12px;

  .contexify_item {
    border-bottom: 0.5px solid ${({ theme }) => theme.sidebar.borderColor};
    padding: 6px 10px;
    &:last-child {
      border-bottom: none;
    }
  }
  .contexify_itemContent {
    color: ${colors.errorColor};
  }
  .contexify_item:not(.contexify_item-disabled):hover > .contexify_itemContent,
  .contexify_item:not(.contexify_item-disabled):focus > .contexify_itemContent {
    color: inherit;
    background-color: ${({ theme }) => theme.menu.selectedOpionBackground};
  }
`;


const PreviewAvatar = styled.div`
  display: flex;
  cursor: pointer;
  align-items:center;
justify-content:center;
  height: 42px;
  width: 42px;
overflow:hidden;
border-radius:100px;

  svg {
    position: relative;
    width: 100%;
    height: 100%;

  }
  img {

    object-fit: cover;
    position: relative;
    height: 43px;
    width: 43px;
  }
`;

const EditButton = styled.p`
cursor:pointer;
color:${({ theme }) => theme.primaryButton.color};
font-weight: 600;
font-size: 12px;
line-height: 100%;
letter-spacing: -0.41px;
text-align: center;
`